import { Assignee } from "./assignee";
import { Attachment } from "./attachment";

export class Story {

    id: number;
    title: string;
     estimate_time: any;
    //estimate_time: number;
    assignee_id: number;
    sprint_id: number;
    description: string = "";
    acc_criteria: string = "";
    effort_time_left: number;
    spent_time: number;
    status: number;
    type: number;
    ver_id: number;
    version_no: number;

    assignee: Assignee;
    attachments: Array<Attachment>;
    subTasks: any;

    constructor(obj: any = {}) {
        this.id = obj.id;
        this.title = obj.title;
        this.estimate_time = obj.estimate_time;
        
        this.assignee_id = obj.assignee ? obj.assignee.emp_number : null;
        this.sprint_id = obj.sprint_id;
        this.description = obj.description ? obj.description : " ";
        this.acc_criteria = obj.acc_criteria ? obj.acc_criteria : " ";
        this.effort_time_left = obj.effort_time_left;
        this.spent_time = obj.spent_time;
        this.status = obj.status;
        this.type = obj.type;
        this.ver_id = obj.ver_id;
        this.version_no = obj.version_no;

        this.assignee = obj.assignee;
        this.attachments = obj.attachments;
        this.subTasks = obj.subTasks;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/story.ts